import type { UseDocumentProps } from '@ztechapps/common.hook'
import { useDocument } from '@ztechapps/common.hook'
import type { Project } from '@ztechapps/common.contract'
import { useProjectIdParam } from './useProjectIdParam'
import { projectDocumentQueries } from './graphql'

export const useProjectDocument = ({ query, ...props } = {} as Partial<UseDocumentProps>) => {
  const projectId = useProjectIdParam()

  const defaultQuery = query ?? projectDocumentQueries.singleConfig.query

  return useDocument<Project>({ query: defaultQuery, _id: projectId, ...props })
}
